import clsx from 'clsx'

import { useCallback } from 'react'
import classes from './styles.module.scss'
import type { SubCabecalhoProps } from './types'

export default function SubCabecalho({
  titulo,
  voltar,
}: SubCabecalhoProps): JSX.Element {
  const handleVoltar = useCallback(() => {
    if (typeof window !== 'undefined' && window.history) {
      window.history.back()
    }
  }, [])
  return (
    <header className="barra-navegacao barra-navegacao">
      <div className="barra-navegacao__container">
        <div className="barra-navegacao__conteudo-principal">
          <div className="barra-navegacao__conteudo-primario">
            {voltar && (
              <button
                type="button"
                className={classes.botaoVoltar}
                onClick={handleVoltar}
              >
                <i className="fa-regular fa-arrow-left" />
              </button>
            )}
            <div
              className={clsx(
                'barra-navegacao__container-titulos',
                classes.tituloContainer
              )}
            >
              <h1 className="barra-navegacao__titulo">{titulo}</h1>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
